import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import LandingTypography from "../../../../landingPage/pages/Homepage/components/LandingTypography";
import "../styles/default.scss";

const Switch = ({
  checked = false,
  disabled = false,
  onChange,
  "aria-label": ariaLabel,
  className
}) => (
  <LandingTypography className="plans squaber-switch-root">
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      className={classNames(
        "squaber-switch",
        {
          "squaber-switch_on": checked,
          "squaber-switch_disabled": disabled
        },
        className
      )}
      onClick={() => {
        if (!disabled) {
          onChange?.(!checked);
        }
      }}
    >
      <span
        className={classNames("squaber-switch__thumb", {
          "squaber-switch__thumb_on": checked
        })}
      />
    </button>
  </LandingTypography>
);

Switch.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  "aria-label": PropTypes.string,
  className: PropTypes.string
};

export default Switch;
